import React from 'react'
import {
  Typography,
} from '@material-ui/core'

export default function TextItem({ content })  {
  return <Typography variant="body1">{content}</Typography>
}